/**
 * 轻量级 JWT 解码（不验签，仅解码 payload）
 * 避免引入完整 jwt-decode 依赖
 */

/** Base64URL 解码 */
function base64UrlDecode(str: string): string {
  // Base64URL → Base64
  let base64 = str.replace(/-/g, '+').replace(/_/g, '/');
  // 补齐 padding
  const pad = base64.length % 4;
  if (pad) {
    base64 += '='.repeat(4 - pad);
  }
  // 解码为字符串
  const binary = atob(base64);
  // 处理 UTF-8
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new TextDecoder('utf-8').decode(bytes);
}

/** 解码 JWT payload */
export function jwtDecode<T = unknown>(token: string): T {
  const parts = token.split('.');
  if (parts.length !== 3) {
    throw new Error('无效的 JWT 格式');
  }
  const payload = parts[1];
  return JSON.parse(base64UrlDecode(payload)) as T;
}
